import { render, staticRenderFns } from "./ThresholdList.vue?vue&type=template&id=31fa669e&"
import script from "./ThresholdList.vue?vue&type=script&lang=js&"
export * from "./ThresholdList.vue?vue&type=script&lang=js&"
import style0 from "./ThresholdList.vue?vue&type=style&index=0&id=31fa669e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports